import * as React from 'react';
import * as Tgcc from '../tgccGlobal';
import {connect} from 'react-redux';
import {browserHistory} from 'react-router';
import Radium, { StyleRoot } from 'radium';
import {CampusHeader} from '../Components/CampusHeader';
import {CampusFooter} from '../Components/CampusFooter';
import {CampusFeedback} from './CampusFeedback';
import { CampusCustomerContent } from '../Components/CampusCustomerContent';
import { MajorAccountsHdr } from '../Components/MajorAccountsHdr';


const imgStyle : React.CSSProperties = {
    width:'250px',
    cursor:'pointer',
    transition:'transform 250ms',
    margin:'10px auto',
    ':hover': {
        transform:'translateY(-10px)'
    }
}
const iconCont: React.CSSProperties = {
    display:'flex',
    flexWrap:'wrap',
    justifyContent:'space-between',
    margin:'25px auto 25px',
    width:'75%'
}

const banImg: React.CSSProperties = {
    width:'100%',
    cursor:'pointer',
    marginBottom:'10px'
}
class _ProductCategoryIcons extends React.Component <Tgcc.BaseProps, any > {

    componentWillMount(){

    }
    onIconClick= (category:string) => {
        if(this.props.location.pathname.toUpperCase().indexOf("CAMPUS") > 0){
            browserHistory.push(Tgcc.Routes.CampusCategoryView(category))
       }
       else{
        browserHistory.push(Tgcc.Routes.CategoryView(category));
       }
    }
    onSearchClick = () => {
        if(this.props.location.pathname.toUpperCase().indexOf("CAMPUS") > 0){
            browserHistory.push(Tgcc.Routes.CampusProductListView);
        }
        else{
            browserHistory.push(Tgcc.Routes.MajorAccountsProductListView);
        }
    }
    render() {

        var hdr = this.props.location.pathname.toUpperCase().indexOf("CAMPUS") > 0 ? <CampusHeader /> : <MajorAccountsHdr />
        var bannerImg = window.innerWidth < 430 ? Tgcc.getProdCatIcon('mobileIconBanner.jpg'):Tgcc.getProdCatIcon('productIconBanner.jpg');  
        return (
                <div>
                    <div id="homepage"></div>
                    {hdr}
                    <CampusFeedback state={this.props.state} />
                    <div style={iconCont} className='iconCont'>
                    <img style={banImg} className='iconBannerImg' onClick={this.onSearchClick} src={bannerImg} />

                        <div onClick={() => this.onIconClick("Pocket")}>
                            <img key={1} style={imgStyle} src={Tgcc.getProdCatIcon('pocketIcon.jpg')} />
                        </div> 
                        <div onClick={() => this.onIconClick("NPSS")}>
                            <img key={2} style={imgStyle} src={Tgcc.getProdCatIcon('npSSIcon.jpg')} />
                        </div> 
                        <div  onClick={() => this.onIconClick("NPLS")}>
                            <img key={3} style={imgStyle} src={Tgcc.getProdCatIcon('npLSIcon.jpg')} />
                        </div> 
                        <div  onClick={() => this.onIconClick("Polo")}>
                            <img key={4} style={imgStyle} src={Tgcc.getProdCatIcon('poloIcon.jpg')} />
                        </div> 
                        <div  onClick={() => this.onIconClick("Tank")}>
                            <img key={5} style={imgStyle} src={Tgcc.getProdCatIcon('tankIcon.jpg')} />
                        </div> 
                        <div  onClick={() => this.onIconClick("Hoodies")}>
                            <img key={6} style={imgStyle} src={Tgcc.getProdCatIcon('hoodieIcon.jpg')} />
                        </div> 
                        <div  onClick={() => this.onIconClick("Crewneck")}>
                            <img key={7} style={imgStyle} src={Tgcc.getProdCatIcon('crewneckIcon.jpg')} />
                        </div> 
                        <div  onClick={() => this.onIconClick("Hats")}>
                            <img key={8} style={imgStyle} src={Tgcc.getProdCatIcon('hatIcon.jpg')} />
                        </div> 
                    </div>
                </div>
        );
    }
}


var radiumProductCategoryIcons = Radium(_ProductCategoryIcons);


const mapStateToProps = (state: Tgcc.GlobalState, ownState: any) => {
    return {
        state: state
    }
};
export var ProductCategoryIcons = connect(mapStateToProps)(radiumProductCategoryIcons);



